import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import DepartmentList from "./DepartmentsList";
import EditDepartment from "./EditDepartments";
import { toast } from "react-toastify";
import { addDepartments } from "services/departmentService";

const Department = (props) => {
  const [addnewform, setaddnewform] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const closeform = () => {
    setaddnewform(false);
  };

  const handleSubmit = async (e) => {
    setIsSubmitting(true);
    try {
      const result = await addDepartments({
        ...e,
        active: true,
      });

      if (result.success) {
        toast.success("Department Added");
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
      setaddnewform(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn setting-btn`}
          onClick={() => {
            setaddnewform(true);
          }}
        >
          Add <br />
          Department
        </Button>
      </div>

      <div className="flex-grow-1 mb-2" style={{ minHeight: 0 }}>
        <DepartmentList />
      </div>

      {addnewform && (
        <EditDepartment
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default Department;
